'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HappinessIndicator;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HappinessIndicator(_ref) {
  var happiness = _ref.happiness,
      className = _ref.className,
      polyglot = _ref.polyglot,
      container = _ref.container;

  var classes = (0, _classnames2.default)('happiness-indicator', className);
  return _react2.default.createElement(
    'div',
    { className: classes },
    _react2.default.createElement(
      'div',
      { className: 'buddy' },
      _react2.default.createElement('span', { className: 'icon-cg-buddies left-icon' })
    ),
    _react2.default.createElement(
      'div',
      { className: 'pull-right' },
      _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          trigger: 'click',
          placement: 'top',
          rootClose: true,
          container: container,
          overlay: _react2.default.createElement(
            _reactBootstrap.Popover,
            { id: 'happinessPopover', animation: false },
            _react2.default.createElement(
              'b',
              null,
              polyglot.t('happiness.help')
            )
          )
        },
        _react2.default.createElement('span', { className: 'icon-cg-list icon-cg-help right-icon' })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'title' },
      polyglot.t('happiness.title')
    ),
    _react2.default.createElement(
      'div',
      { className: 'progress' },
      _react2.default.createElement(
        'div',
        {
          className: 'progress-bar',
          role: 'progressbar',
          'aria-valuenow': happiness,
          'aria-valuemin': '0',
          'aria-valuemax': '100',
          style: { width: happiness + '%' }
        },
        _react2.default.createElement(
          'span',
          { className: 'sr-only' },
          happiness,
          '% Happy'
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Event/HappinessIndicator.js
// module id = 2197
// module chunks = 0